<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ 'home.paymentForm.title' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="h-100">
    @if (true) {
      <mat-tab-group class="formTabs"
        [selectedIndex]="selectedIndex"
        dynamicHeight
        (selectedTabChange)="tabChanged($event)"
        >
        <mat-tab [disabled]="selectedIndex != 0" [label]="'home.paymentForm.title' | translate">
          <div class="tab invoice-search-tab">
            <odq-ngc-positive-control-probe></odq-ngc-positive-control-probe>

            <section class="info-box">
              <div class="box-header">
                <mat-icon class="box-header-icon icon-lg">info</mat-icon>
                <div>
                  <h3>{{ 'home.paymentForm.importantInfo.title' | translate }}</h3>
                  <p class="box-intro">{{ 'home.paymentForm.importantInfo.intro' | translate }}</p>
                </div>
              </div>

              <div class="info-lists" [class.is-stacked]="!isDesktop">
                <mat-expansion-panel class="flat-panel list-panel"
                  [class.is-collapsible]="!isDesktop"
                  [expanded]="isDesktop"
                  [hideToggle]="isDesktop">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (isDesktop) {
                        <mat-icon class="icon-yes">check_circle</mat-icon>
                        <span class="text-yes">{{ 'home.paymentForm.importantInfo.payableTitleShort' | translate }}</span>
                      } @else {
                        <mat-icon class="icon-yes">check</mat-icon>
                        <span>{{ 'home.paymentForm.importantInfo.payableTitle' | translate }}</span>
                      }
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="icon-list">
                    <li>
                      <mat-icon class="icon-yes">check</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.payableDepartments' | translate }}</span>
                    </li>
                    <li>
                      <mat-icon class="icon-yes">check</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.payableFarpodqRecovery' | translate }}</span>
                    </li>
                    <li>
                      <mat-icon class="icon-yes">check</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.payableTraining' | translate }}</span>
                    </li>
                    <li>
                      <mat-icon class="icon-yes">check</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.payableOtherServices' | translate }}</span>
                    </li>
                  </ul>
                </mat-expansion-panel>

                <mat-expansion-panel class="flat-panel list-panel"
                  [class.is-collapsible]="!isDesktop"
                  [expanded]="isDesktop"
                  [hideToggle]="isDesktop">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (isDesktop) {
                        <mat-icon class="icon-no">cancel</mat-icon>
                        <span class="text-no">{{ 'home.paymentForm.importantInfo.notPayableTitleShort' | translate }}</span>
                      } @else {
                        <mat-icon class="icon-no">close</mat-icon>
                        <span>{{ 'home.paymentForm.importantInfo.notPayableTitle' | translate }}</span>
                      }
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="icon-list">
                    <li>
                      <mat-icon class="icon-no">close</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.notPayableFarpodq' | translate }}</span>
                    </li>
                    <li>
                      <mat-icon class="icon-no">close</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.notPayableRegistration' | translate }}</span>
                    </li>
                    <li>
                      <mat-icon class="icon-no">close</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.notPayableMembershipFee' | translate }}</span>
                    </li>
                    <li>
                      <mat-icon class="icon-no">close</mat-icon>
                      <span>{{ 'home.paymentForm.importantInfo.notPayableAnnualDeclaration' | translate }}</span>
                    </li>
                  </ul>
                  <div class="box-footer">{{ 'home.paymentForm.importantInfo.footer' | translate }}</div>
                </mat-expansion-panel>
              </div>
            </section>

            <div class="search-layout">
              <section class="search-panel">
                <div class="box-header">
                  <span class="icon-badge"><mat-icon>search</mat-icon></span>
                  <h3>{{ 'home.paymentForm.searchTitle' | translate }}</h3>
                </div>
                <form [formGroup]="invoiceForm">
                  <div class="form-container d-flex flex-column" style="gap: 12px">
                    <label class="field-label" for="billNumber">{{ 'home.paymentForm.billNumber' | translate }}*</label>
                    <mat-form-field appearance="outline" class="control-width" subscriptSizing="dynamic">
                      <input matInput id="billNumber" formControlName="billNumber" required />
                      <mat-hint>{{ 'home.paymentForm.hints.billNumber' | translate }}</mat-hint>
                      @if (invoiceForm.controls['billNumber'].hasError('required')) {
                        <mat-error>
                          {{'form.validation.required' | translate}}
                        </mat-error>
                      }
                    </mat-form-field>
                    <label class="field-label" for="payerName">{{ 'home.paymentForm.payerName' | translate }}*</label>
                    <mat-form-field appearance="outline" class="control-width" subscriptSizing="dynamic">
                      <input matInput id="payerName" formControlName="payerName" required />
                      <mat-hint>{{ 'home.paymentForm.hints.payerName' | translate }}</mat-hint>
                      @if (invoiceForm.controls['payerName'].hasError('required')) {
                        <mat-error>
                          {{'form.validation.required' | translate}}
                        </mat-error>
                      }
                    </mat-form-field>
                    <label class="field-label" for="amount">{{ 'home.paymentForm.amount' | translate }}*</label>
                    <mat-form-field appearance="outline" class="control-width" subscriptSizing="dynamic">
                      <input matInput id="amount" formControlName="amount" required type="number" min="0" step="0.01" />
                      <mat-hint>{{ 'home.paymentForm.hints.amount' | translate }}</mat-hint>
                      @if (invoiceForm.controls['amount'].hasError('required')) {
                        <mat-error>
                          {{'form.validation.required' | translate}}
                        </mat-error>
                      }
                      @if (invoiceForm.controls['amount'].hasError('pattern')) {
                        <mat-error>
                          {{'form.validation.invalidAmount' | translate}}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="mt-3 search-actions d-flex justify-content-start align-items-center" style="gap: 10px">
                    <button mat-raised-button
                      (click)="searchInvoice()"
                      [disabled]="invoiceForm.invalid || (loading$ | async)">
                      <mat-icon>search</mat-icon>
                      {{ 'home.paymentForm.search' | translate }}
                    </button>
                    @if (loading$ | async) {
                      <mat-spinner diameter="24"></mat-spinner>
                    }
                  </div>
                  @if ((error$ | async); as error) {
                    <div class="mt-2 d-flex">
                      <div class="form-warning">
                        <p class="text-danger">{{ error }}</p>
                      </div>
                    </div>
                  }
                  <div class="mandatory-note">
                    <mat-icon>info</mat-icon>
                    <span>{{ 'home.paymentForm.mandatoryFields' | translate }}</span>
                  </div>
                </form>
              </section>

              <aside class="help-panel">
                <mat-expansion-panel class="flat-panel help-card"
                  [class.is-collapsible]="!isDesktop"
                  [expanded]="isDesktop"
                  [hideToggle]="isDesktop">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="box-header-icon">info_outline</mat-icon>
                      <div class="panel-title-text">
                        <span>{{ 'home.paymentForm.about.title' | translate }}</span>
                        @if (isTablet) {
                          <span class="panel-subtitle">{{ 'home.paymentForm.about.intro' | translate }}</span>
                        }
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @if (!isTablet) {
                    <p class="box-intro">{{ 'home.paymentForm.about.intro' | translate }}</p>
                  }
                  <p class="box-intro">{{ 'home.paymentForm.about.requirements' | translate }}</p>
                  <div class="help-item">
                    <span class="icon-badge"><mat-icon>tag</mat-icon></span>
                    <div>
                      <div class="help-item-title">{{ 'home.paymentForm.billNumber' | translate }}</div>
                      <div class="help-item-desc">{{ 'home.paymentForm.about.billNumberDesc' | translate }}</div>
                    </div>
                  </div>
                  <div class="help-item">
                    <span class="icon-badge"><mat-icon>person</mat-icon></span>
                    <div>
                      <div class="help-item-title">{{ 'home.paymentForm.payerName' | translate }}</div>
                      <div class="help-item-desc">{{ 'home.paymentForm.about.payerNameDesc' | translate }}</div>
                    </div>
                  </div>
                  <div class="help-item">
                    <span class="icon-badge"><mat-icon>attach_money</mat-icon></span>
                    <div>
                      <div class="help-item-title">{{ 'home.paymentForm.amount' | translate }}</div>
                      <div class="help-item-desc">{{ 'home.paymentForm.about.amountDesc' | translate }}</div>
                    </div>
                  </div>
                </mat-expansion-panel>

                <mat-expansion-panel class="flat-panel help-card"
                  [class.is-collapsible]="isMobile"
                  [expanded]="!isMobile"
                  [hideToggle]="!isMobile">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="box-header-icon">lightbulb_outline</mat-icon>
                      <span>{{ 'home.paymentForm.about.tipTitle' | translate }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <p class="box-intro">{{ 'home.paymentForm.about.tipDesc' | translate }}</p>
                </mat-expansion-panel>
              </aside>
            </div>
          </div>
        </mat-tab>
        <mat-tab [disabled]="selectedIndex != 1" [label]="'home.paymentForm.payment' | translate">
          <div class="tab payment-step">
            @if (!isLoading && !paymentSuccess) {
              @if (result$ | async; as result) {
                <div class="payment-tab">
                  <section class="found-box" role="status">
                    <mat-icon class="found-icon">check_circle</mat-icon>
                    <div>
                      <h3>{{ 'home.paymentForm.found' | translate }}</h3>
                      <div class="box-text">{{ 'home.paymentForm.invoiceFound.matchMessage' | translate }}</div>
                      <div class="box-text">{{ 'home.paymentForm.invoiceFound.verifyMessage' | translate }}</div>
                    </div>
                  </section>

                  <div class="payment-layout">
                    <div class="payment-column">
                      <mat-expansion-panel class="flat-panel pay-card summary-card"
                        [class.is-collapsible]="!isDesktop"
                        [expanded]="!isMobile"
                        [hideToggle]="isDesktop">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <mat-icon class="card-title-icon">receipt_long</mat-icon>
                            <span>{{ 'home.paymentForm.summary.title' | translate }}</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="payer-info">
                          <h4>{{ result.payerFullName }}</h4>
                          <div class="payer-meta">
                            <span>{{ 'home.paymentForm.billNumber' | translate }} : {{ result.billCode }}</span>
                            <span>{{ 'home.paymentForm.date' | translate }} : {{ result.billDate | date:'longDate':undefined:dateLocale }}</span>
                          </div>
                        </div>

                        <div class="bill-lines">
                          @for (line of result.billLines; track line.billLineId) {
                            <div class="summary-row">
                              <span>{{ getLineDescription(line) }}</span>
                              <span class="amount">{{ formatAmount(line.amount) }}</span>
                            </div>
                          }
                        </div>

                        <div class="summary-totals">
                          <div class="summary-row strong">
                            <span>{{ 'home.paymentForm.summary.subtotal' | translate }}</span>
                            <span class="amount">{{ formatAmount(getSubtotal(result)) }}</span>
                          </div>
                          @if (result.tpsAmount > 0) {
                            <div class="summary-row strong">
                              <span>{{ 'home.paymentForm.summary.tps' | translate }}</span>
                              <span class="amount">{{ formatAmount(result.tpsAmount) }}</span>
                            </div>
                          }
                          @if (result.tvqAmount > 0) {
                            <div class="summary-row strong">
                              <span>{{ 'home.paymentForm.summary.tvq' | translate }}</span>
                              <span class="amount">{{ formatAmount(result.tvqAmount) }}</span>
                            </div>
                          }
                        </div>

                        <div class="total-due">
                          <span class="total-label">{{ 'home.paymentForm.summary.totalDue' | translate }}</span>
                          <span class="total-amount">{{ formatAmount(result.amount) }}</span>
                        </div>
                      </mat-expansion-panel>

                      <mat-expansion-panel class="flat-panel pay-card secure-card"
                        [class.is-collapsible]="!isDesktop"
                        [expanded]="isDesktop"
                        [hideToggle]="isDesktop">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <mat-icon class="card-title-icon">lock_outline</mat-icon>
                            <span>{{ 'home.paymentForm.securePayment.title' | translate }}</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="box-text">{{ 'home.paymentForm.securePayment.message' | translate }}</div>
                        <div class="box-text">{{ 'home.paymentForm.securePayment.noCardStorage' | translate }}</div>
                      </mat-expansion-panel>
                    </div>

                    <div class="payment-column">
                      <section class="pay-card payment-card">
                        <div class="card-title">
                          <mat-icon class="card-title-icon">credit_card</mat-icon>
                          <h3>{{ 'home.paymentForm.paymentInfo.title' | translate }}</h3>
                        </div>

                        @if (!hidePayment && showPaymentForm && selectedIndex === 1) {
                          <odq-payment
                            variant="modern"
                            [monerisStoreId]="storeId"
                            [canSubmit]="canSubmitPayment"
                            [submitLabel]="'home.paymentForm.paymentInfo.pay' | translate:{ amount: formatAmount(result.amount) }"
                            (dataKeyCreated)="doPayment($event)">
                            <label class="field-label" for="nameUnderCard">{{ 'home.paymentForm.paymentInfo.cardholderName' | translate }} *</label>
                            <mat-form-field appearance="outline" class="control-width" subscriptSizing="dynamic">
                              <input matInput
                                id="nameUnderCard"
                                name="nameUnderCard"
                                autocomplete="cc-name"
                                required
                                [(ngModel)]="nameUnderCard"
                                [placeholder]="'home.paymentForm.paymentInfo.cardholderNamePlaceholder' | translate" />
                              <mat-hint>{{ 'home.paymentForm.paymentInfo.cardholderNameHint' | translate }}</mat-hint>
                            </mat-form-field>

                            <div class="important-box">
                              <mat-icon>info_outline</mat-icon>
                              <div>
                                <strong>{{ 'home.paymentForm.paymentInfo.importantTitle' | translate }}</strong>
                                <div class="box-text">{{ 'home.paymentForm.paymentInfo.importantMessage' | translate }}</div>
                              </div>
                            </div>

                            <div class="confirmations">
                              <mat-checkbox color="primary" name="invoiceVerified" [(ngModel)]="invoiceVerified">
                                {{ 'home.paymentForm.paymentInfo.invoiceVerified' | translate }}
                              </mat-checkbox>
                              <mat-checkbox color="primary" name="chargeAuthorized" [(ngModel)]="chargeAuthorized">
                                {{ 'home.paymentForm.paymentInfo.chargeAuthorized' | translate }}
                              </mat-checkbox>
                            </div>

                            <button odqPaymentActions mat-stroked-button type="button" (click)="cancelPayment()">
                              {{ 'home.paymentForm.paymentInfo.back' | translate }}
                            </button>
                          </odq-payment>
                        }

                        @if (!hidePayment && !showPaymentForm) {
                          <div class="spinner-container">
                            <mat-spinner [diameter]="32"></mat-spinner>
                          </div>
                        }

                        @if (paymentError && hidePayment) {
                          <div class="paymentError d-flex flex-column" style="gap: 8px">
                            <h4>{{paymentError}}</h4>
                            @if (canRetry) {
                              <div class="retryDiv">
                                <span>{{'memberBills.invoicePayment.reassuranceMessage' | translate}}</span>
                                <button mat-raised-button (click)="retryPayment()">
                                  {{'navigation.retry' | translate}}
                                </button>
                              </div>
                            }
                          </div>
                          <div class="mt-3 back-button-container">
                            <button mat-stroked-button type="button" (click)="cancelPayment()">
                              {{ 'home.paymentForm.paymentInfo.back' | translate }}
                            </button>
                          </div>
                        }
                      </section>
                    </div>
                  </div>
                </div>
              }
            } @else {
              @if (isLoading) {
                <div class="row loader">
                  <div class="spinner-container">
                    <mat-spinner></mat-spinner>
                  </div>
                </div>
              }
              @if (paymentSuccess && paymentReceipt) {
                <div class="payment-confirmation">
                  <section class="confirmation-banner" role="status">
                    <mat-icon class="confirmation-banner-icon">check_circle</mat-icon>
                    <div>
                      <h2>{{ 'home.paymentForm.confirmation.title' | translate }}</h2>
                      <div class="box-text">{{ 'home.paymentForm.confirmation.processed' | translate }}</div>
                      <div class="box-text">{{ 'home.paymentForm.confirmation.invoicePaid' | translate }}</div>
                    </div>
                  </section>

                  <div class="confirmation-layout">
                    <section class="pay-card amount-card">
                      <div class="amount-title">
                        @if (isDesktop) {
                          <mat-icon class="card-title-icon">paid</mat-icon>
                        }
                        <h3>{{ 'home.paymentForm.confirmation.amountPaid' | translate }}</h3>
                      </div>
                      <div class="amount-value">
                        @if (isTablet) {
                          <mat-icon class="card-title-icon">paid</mat-icon>
                        }
                        <span>{{ formatAmount(paymentReceipt.amount) }}</span>
                      </div>
                    </section>

                    <mat-expansion-panel class="flat-panel pay-card invoice-card"
                      [class.is-collapsible]="isMobile"
                      [expanded]="!isMobile"
                      [hideToggle]="!isMobile">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <mat-icon class="card-title-icon">description</mat-icon>
                          <span>{{ 'home.paymentForm.confirmation.invoiceCard.title' | translate }}</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      @if (result$ | async; as result) {
                        <dl class="detail-list">
                          <div class="detail-row">
                            <dt>{{ 'home.paymentForm.confirmation.invoiceCard.number' | translate }}</dt>
                            <dd class="invoice-number">{{ result.billCode }}</dd>
                          </div>
                          <div class="detail-row">
                            <dt>{{ 'home.paymentForm.confirmation.invoiceCard.date' | translate }}</dt>
                            <dd>{{ result.billDate | date:'longDate':undefined:dateLocale }}</dd>
                          </div>
                          <div class="detail-row">
                            <dt>{{ 'home.paymentForm.confirmation.invoiceCard.description' | translate }}</dt>
                            <dd>{{ getInvoiceDescription(result) }}</dd>
                          </div>
                        </dl>
                      }
                    </mat-expansion-panel>

                    <mat-expansion-panel class="flat-panel pay-card receipt-card"
                      [class.is-collapsible]="isMobile"
                      [expanded]="true"
                      [hideToggle]="!isMobile">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <mat-icon class="card-title-icon">lock_outline</mat-icon>
                          <span>{{ 'home.paymentForm.confirmation.receiptCard.title' | translate }}</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <dl class="detail-list">
                        <div class="detail-row">
                          <dt>{{ 'home.paymentForm.confirmation.receiptCard.transactionId' | translate }}</dt>
                          <dd>{{ paymentReceipt.orderId }}</dd>
                        </div>
                        <div class="detail-row">
                          <dt>{{ 'home.paymentForm.confirmation.receiptCard.dateTime' | translate }}</dt>
                          <dd>{{ formatTransactionDate(paymentReceipt.date) }}</dd>
                        </div>
                        <div class="detail-row">
                          <dt>{{ 'home.paymentForm.confirmation.receiptCard.cardType' | translate }}</dt>
                          <dd>{{ getCardTypeLabel(paymentReceipt.monerisCardType) }}</dd>
                        </div>
                        <div class="detail-row">
                          <dt>{{ 'home.paymentForm.confirmation.receiptCard.cardNumber' | translate }}</dt>
                          <dd>{{ paymentReceipt.creditCardNumber }}</dd>
                        </div>
                        <div class="detail-row">
                          <dt>{{ 'home.paymentForm.confirmation.receiptCard.authorization' | translate }}</dt>
                          <dd>{{ paymentReceipt.authorizationNumber }}</dd>
                        </div>
                      </dl>
                    </mat-expansion-panel>
                  </div>

                  <ul class="confirmation-checks">
                    <li>
                      <mat-icon>verified_user</mat-icon>
                      <span>{{ 'home.paymentForm.confirmation.checks.invoicePaid' | translate }}</span>
                    </li>
                    <li>
                      <mat-icon>account_balance</mat-icon>
                      <span>{{ (isDesktop ? 'home.paymentForm.confirmation.checks.authorized' : 'home.paymentForm.confirmation.checks.authorizedShort') | translate }}</span>
                    </li>
                    <li>
                      <mat-icon>task_alt</mat-icon>
                      <span>{{ 'home.paymentForm.confirmation.checks.noAction' | translate }}</span>
                    </li>
                  </ul>

                  <div class="confirmation-message">{{ 'home.paymentForm.confirmation.thankYou' | translate }}</div>

                  <div class="confirmation-actions">
                    <button mat-flat-button color="primary" type="button" class="action-another" (click)="setSelectedIndex(0)">
                      @if (isDesktop) {
                        <mat-icon>request_quote</mat-icon>
                      }
                      {{ 'home.paymentForm.confirmation.actions.anotherPayment' | translate }}
                    </button>
                    <button mat-stroked-button color="primary" type="button" class="action-home" (click)="goHome()">
                      <mat-icon>home</mat-icon>
                      {{ 'home.paymentForm.confirmation.actions.home' | translate }}
                    </button>
                    <button mat-stroked-button color="primary" type="button" class="action-print" (click)="printReceipt()">
                      <mat-icon>print</mat-icon>
                      {{ 'home.paymentForm.confirmation.actions.print' | translate }}
                    </button>
                  </div>
                </div>
              }
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    }
  </mat-card-content>
</mat-card>
